import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pantry-used-up-check-item" }
const _hoisted_2 = { class: "pantry-used-up-check-item-summry-area" }
const _hoisted_3 = { class: "pantry-used-up-check-item-summry-name" }
const _hoisted_4 = { class: "pantry-used-up-check-item-date-area" }
const _hoisted_5 = { class: "pantry-used-up-check-item-date-text" }
const _hoisted_6 = { class: "pantry-used-up-check-item-status-area" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PantryUsedUpCheckTagItem = _resolveComponent("PantryUsedUpCheckTagItem")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("img", {
        class: "pantry-used-up-check-item-summry-image",
        src: _ctx.getImage(),
        onError: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onImageError(...args)))
      }, null, 40, ["src"]),
      _createVNode("div", _hoisted_3, [
        _createVNode("div", {
          class: "pantry-used-up-check-item-summry-name-text",
          style: _ctx.styleText
        }, _toDisplayString(_ctx.getName()), 5)
      ])
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, _toDisplayString(_ctx.getPurchaseDate()), 1)
    ]),
    _createVNode("div", _hoisted_6, [
      _createVNode(_component_PantryUsedUpCheckTagItem, {
        label: '捨てた',
        id: _ctx.PLATE_DELETE_FOOD_STATUS.THREW_AWAY,
        active: _ctx.getActive(),
        onSelectTag: _ctx.onSelectTag
      }, null, 8, ["id", "active", "onSelectTag"]),
      _createVNode(_component_PantryUsedUpCheckTagItem, {
        label: '使い切った',
        id: _ctx.PLATE_DELETE_FOOD_STATUS.USED,
        active: _ctx.getActive(),
        onSelectTag: _ctx.onSelectTag
      }, null, 8, ["id", "active", "onSelectTag"])
    ])
  ]))
}